import React, { createContext, useContext, useState } from "react";

import { DeviceAC, Environment } from "libLegacy/api/models";
import { AutomationSpace } from "api/automationTypes";

export type DeviceContextProps = {
  chosenBuilding: AutomationSpace | undefined;
  setChosenBuilding: React.Dispatch<
    React.SetStateAction<AutomationSpace | undefined>
  >;
  chosenEnvironment: Environment | undefined;
  setChosenEnvironment: React.Dispatch<
    React.SetStateAction<Environment | undefined>
  >;
  chosenAC: DeviceAC | undefined;
  setChosenAC: React.Dispatch<React.SetStateAction<DeviceAC | undefined>>;
};

export const DeviceContext = createContext<DeviceContextProps>(null!);

export const DeviceProvider = ({ children }) => {
  const [chosenBuilding, setChosenBuilding] = useState<AutomationSpace>();
  const [chosenEnvironment, setChosenEnvironment] = useState<
    Environment | undefined
  >();
  const [chosenAC, setChosenAC] = useState<DeviceAC | undefined>();

  return (
    <DeviceContext.Provider
      value={{
        chosenBuilding,
        setChosenBuilding,
        chosenEnvironment,
        setChosenEnvironment,
        chosenAC,
        setChosenAC,
      }}
    >
      {children}
    </DeviceContext.Provider>
  );
};

export const useDeviceContext = () => {
  const {
    chosenBuilding,
    setChosenBuilding,
    chosenEnvironment,
    setChosenEnvironment,
    chosenAC,
    setChosenAC,
  } = useContext(DeviceContext);
  return {
    chosenBuilding,
    setChosenBuilding,
    chosenEnvironment,
    setChosenEnvironment,
    chosenAC,
    setChosenAC,
  };
};
